import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { AssetTransactionFragment } from '../../graphql/assetTransaction.graphql';
import { AssetTransaction } from '../../types/asset_transaction/assetTransaction';
import { useAppDispatch } from '../../ui/pages/store';
import { assetTransactionSlice } from '../../providers/AssetTransactionProvider';

const assetTransactionSubscription = gql`
  subscription assetTransactionNotification($companyId: String!) {
    assetTransactionNotification(companyId: $companyId) {
      companyId
      entities {
        ...AssetTransaction
      }
      topic
      date
    }
  }
  ${AssetTransactionFragment.assetTransaction}
`;

export class AssetTransactionNotificationResponse extends forNotification<AssetTransaction>(
  'assetTransactionNotification',
) {}

export default function AssetTransactionNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: assetTransactionNotification } = useSubscription<AssetTransactionNotificationResponse>(
    assetTransactionSubscription,
    {
      variables: { companyId: currentCompany.id },
    },
  );

  const handleAssetTransactionNotification = (notification?: AssetTransactionNotificationResponse) => {
    if (!notification?.assetTransactionNotification) return;
    const assetTransactionNotification = notification.assetTransactionNotification;

    switch (assetTransactionNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(assetTransactionSlice.actions.add(assetTransactionNotification.entities));
        break;
      case 'DELETE':
        dispatch(assetTransactionSlice.actions.delete(assetTransactionNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleAssetTransactionNotification(assetTransactionNotification);
  }, [assetTransactionNotification]);

  return <></>;
}
